import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const ModalWrapper = styled.div`
  display: ${props => (props.show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  overflow-y: auto;
  max-height: 100vh;
  .overlay {
    background-color: rgba(255, 255, 255, 0.5);
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
  .modal-container {
    position: relative;
    z-index: 99999;
    min-width: 473px;
    min-height: 32%;
    //min-height: 214px;
    -webkit-box-shadow: 0 2px 14px 0 #cccccc;
    -moz-box-shadow: 0 2px 14px 0 #cccccc;
    box-shadow: 0 2px 14px 0 #cccccc;
    background-color: ${Variables.colors.complementary};
    .modal-header {
      height: 60px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 16px;
      padding-right: 16px;
      .modal-title-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 29px;
        height: 29px;
        &:before {
          margin: 0;
          font-size: 20px;
          color: ${props =>
            Variables.colors[props.iconColor] || props.iconColor};
        }
      }
      .modal-header-title {
        padding: 0 8px;
        width: calc(100% - 45px);
        font-size: ${props =>
          props.bigTitle
            ? Variables.font_sizes.x2_large
            : Variables.font_sizes.x2_medium};
        color: ${Variables.colors.complementary_900};
        span {
          color: ${Variables.colors.primary_vivid};
        }
      }
      .modal-close-icon {
        cursor: pointer;
        display: ${props => (props.close === false ? "none" : "flex")};
        justify-content: center;
        align-items: center;
        width: 29px;
        height: 29px;
        border-radius: 50%;
        &:before {
          margin: 0;
          font-size: 11px;
          color: ${Variables.colors.complementary_900};
        }
        &:hover {
          background-color: ${Variables.colors.complementary_300};
        }
      }
    }
    .modal-body {
      min-height: calc(100% - 130px);
      width: 100%;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 16px;
      //max-height: calc(100vh - 130px);
      //overflow-y: auto;
    }
    .modal-footer {
      height: 70px;
      width: 100%;
      display: flex;
      justify-content: ${props => props.buttonAlign || "flex-end"};
      align-items: center;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 10px;
      .button-separator {
        width: 8px;
      }
    }
  }
`;
